import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axiosInstance from "../../utils/axios";
// utils

// ----------------------------------------------------------------------

const initialState = {
  isLoading: false,
  fetchLoading: false,
  ratings: {
    data: [],
    meta: {
      total: 0,
    },
  },
};

// TODO: fetch all the ratings
export const fetchRatings = createAsyncThunk(
  "fetchRatings/ratings",
  async ({ enqueueSnackbar, limit = 100, page = 0, filter }, thunkApi) => {
    try {
      const response = await axiosInstance.get(`ratings`, {
        params: {
          page: page + 1,
          limit,
          ...(filter &&
            filter.user_type && {
              user_type: filter.user_type,
            }),
        },
      });

      return {
        data: response.data.data.items,
        meta: {
          total: response.data.data.meta?.total,
        },
      };
    } catch (error) {
      return thunkApi.rejectWithValue({ error, enqueueSnackbar });
    }
  }
);

// TODO: create rating
export const createRating = createAsyncThunk(
  "createRating/ratings",
  async ({ data, enqueueSnackbar, handleClose }, thunkApi) => {
    try {
      const response = await axiosInstance.post(`ratings`, data);

      return {
        data: response.data.data,
        handleClose,
        enqueueSnackbar,
      };
    } catch (error) {
      return thunkApi.rejectWithValue({ error, enqueueSnackbar });
    }
  }
);

// TODO: update rating
export const updateRating = createAsyncThunk(
  "updateRating/ratings",
  async ({ data, enqueueSnackbar, handleClose, id }, thunkApi) => {
    try {
      const response = await axiosInstance.patch(`ratings/${id}`, data);

      return {
        data: response.data.data,
        handleClose,
        enqueueSnackbar,
      };
    } catch (error) {
      return thunkApi.rejectWithValue({ error, enqueueSnackbar });
    }
  }
);

// TODO: delete rating
export const deleteRating = createAsyncThunk(
  "deleteRating/ratings",
  async ({ enqueueSnackbar, handleClose, id }, thunkApi) => {
    try {
      await axiosInstance.delete(`ratings/${id}`);
      return {
        data: id,
        handleClose,
        enqueueSnackbar,
      };
    } catch (error) {
      return thunkApi.rejectWithValue({ error, enqueueSnackbar });
    }
  }
);

const ratingslice = createSlice({
  name: "rating",
  initialState,
  extraReducers: (builder) => {
    // TODO: create rating
    builder.addCase(fetchRatings.pending, (state, _) => {
      state.fetchLoading = true;
    });

    builder.addCase(fetchRatings.fulfilled, (state, action) => {
      state.fetchLoading = false;
      state.ratings = action.payload;
    });

    builder.addCase(fetchRatings.rejected, (state, action) => {
      state.isLoading = false;
      state.fetchLoading = false;
      action.payload.enqueueSnackbar(
        JSON.stringify(
          action.payload.error ||
            action.payload.error.errors ||
            action.payload.error.message
        ),
        {
          variant: "error",
        }
      );
    });

    // TODO: create rating
    builder.addCase(createRating.pending, (state, _) => {
      state.isLoading = true;
    });

    builder.addCase(createRating.fulfilled, (state, action) => {
      state.isLoading = false;
      state.ratings.data = [action.payload.data, ...state.ratings.data];
      state.ratings.meta.total = state.ratings.meta.total + 1;
      action.payload.enqueueSnackbar("RATING is created successfully.", {
        variant: "success",
      });
      action.payload.handleClose && action.payload.handleClose();
    });

    builder.addCase(createRating.rejected, (state, action) => {
      state.isLoading = false;
      action.payload.enqueueSnackbar(
        JSON.stringify(
          action.payload.error ||
            action.payload.error.errors ||
            action.payload.error.message
        ),
        {
          variant: "error",
        }
      );
    });

    // TODO: update rating
    builder.addCase(updateRating.pending, (state, _) => {
      state.isLoading = true;
    });

    builder.addCase(updateRating.fulfilled, (state, action) => {
      state.isLoading = false;
      state.ratings.data = state.ratings.data.map((rating) => {
        if (rating.id === action.payload.data.id) {
          return action.payload.data;
        } else {
          return rating;
        }
      });
      action.payload.enqueueSnackbar("RATING is updated successfully.", {
        variant: "success",
      });
      action.payload.handleClose && action.payload.handleClose();
    });

    builder.addCase(updateRating.rejected, (state, action) => {
      state.isLoading = false;
      action.payload.enqueueSnackbar(
        JSON.stringify(
          action.payload.error ||
            action.payload.error.errors ||
            action.payload.error.message
        ),
        {
          variant: "error",
        }
      );
    });

    // TODO: delete rating
    builder.addCase(deleteRating.pending, (state, _) => {
      state.isLoading = true;
    });

    builder.addCase(deleteRating.fulfilled, (state, action) => {
      state.isLoading = false;
      state.ratings.data = state.ratings.data.filter(
        (rating) => rating.id !== action.payload.data
      );
      action.payload.enqueueSnackbar("RATING is deleted successfully.", {
        variant: "success",
      });
      action.payload.handleClose && action.payload.handleClose();
    });

    builder.addCase(deleteRating.rejected, (state, action) => {
      state.isLoading = false;
      action.payload.enqueueSnackbar(
        JSON.stringify(
          action.payload.error ||
            action.payload.error.errors ||
            action.payload.error.message
        ),
        {
          variant: "error",
        }
      );
    });
  },
});

export default ratingslice.reducer;
